import { cn } from '@/lib/cn.ts';
import type { ReservationStatus } from '@okn/shared';

type Tone = 'gold' | 'success' | 'danger' | 'muted' | 'accent' | 'held';

const TONE: Record<Tone, string> = {
  gold: 'bg-gold-quiet text-gold',
  success: 'bg-[rgba(106,168,79,0.15)] text-success',
  danger: 'bg-accent-faint text-accent',
  accent: 'bg-accent-quiet text-accent',
  muted: 'bg-surface text-text-muted',
  held: 'bg-[rgba(139,109,214,0.16)] text-[var(--seat-held)]',
};

type BadgeProps = {
  tone?: Tone;
  dot?: boolean;
  children: React.ReactNode;
  className?: string;
};

export function Badge({ tone = 'muted', dot, children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-[5px] px-2 py-0.5 text-[11px] font-medium',
        TONE[tone],
        className,
      )}
    >
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />}
      {children}
    </span>
  );
}

const STATUS: Record<ReservationStatus, { label: string; tone: Tone }> = {
  reserved: { label: 'Ön Rezervasyon', tone: 'gold' },
  paid: { label: 'Onaylandı', tone: 'success' },
  cancelled: { label: 'İptal', tone: 'danger' },
  no_show: { label: 'Gelmedi', tone: 'muted' },
};

export function StatusBadge({
  status,
  size = 'sm',
}: {
  status: ReservationStatus;
  size?: 'sm' | 'lg';
}) {
  const s = STATUS[status];
  return (
    <Badge tone={s.tone} dot className={size === 'lg' ? 'px-3 py-1 text-xs' : undefined}>
      {s.label}
    </Badge>
  );
}
